import ReactDOM from "react-dom/client";
import "@fontsource/geist";
import "@fontsource/geist-mono";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AppContextProvider } from "./store/app.context";
import { App as AntdApp } from "antd";
import locale from "antd/locale/id_ID";
import "antd/dist/reset.css";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./components/ThemeProvider";
import dayjs from "dayjs";

dayjs.locale(locale.locale);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
	<AppContextProvider>
		<ThemeProvider>
			<AntdApp>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</AntdApp>
		</ThemeProvider>
	</AppContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
